export * from "./recommendation-widget-page.view";
export * from "./widget-config-page";